//Custom components

import BarChart from '@/components/UI/Charts/BarChart';
import { CurrencyFormatDisplay } from '@/components/UI/NumberFormatDisplay/CurrencyFormatDisplay';

//Services
import { useDashboardData } from '@/hooks/ReactQueryHooks/useDashboardQuery';

//Assets and Miscellaneous
import type { DashboardType } from '@/types/Analytics.ts';
import Card from '../../UI/Card/index.tsx';
import { Widget } from '../constants';
import WidgetLayout from '../WidgetLayout';

interface UsesWidgetDataResponse {
  name: string;
  total_amount: number;
}

export default function TotalProjectUsesWidget({ dashboard }: { dashboard: DashboardType }) {
  const fetchUsesWidgetData = useDashboardData({
    dashboard,
    widget: Widget.PROJECTS_BY_USES,
  });

  const usesWidgetData = fetchUsesWidgetData?.data?.data;

  const usesLabels: string[] = usesWidgetData?.map((data: UsesWidgetDataResponse) => data?.name);

  const usesDatasets: number[] = usesWidgetData?.map((data: UsesWidgetDataResponse) => data?.total_amount);

  const totalUses: number = usesDatasets?.reduce((acc: number, next: number) => acc + next, 0);

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.PROJECTS_BY_USES} actionsBtnLocation='hidden'>
      <section className='flex gap-8 h-full'>
        <Card title='Project Uses' error={fetchUsesWidgetData.isError}>
          {fetchUsesWidgetData && (
            <>
              <div className='flex flex-row justify-between items-center px-8 py-4'>
                <span className='flex flex-col'>
                  <p className='text-gray-400 text-sm'>Total Uses</p>
                  <p className='text-black-800 font-bold text-lg'>
                    <CurrencyFormatDisplay value={totalUses} prefix='$' />
                  </p>
                </span>
              </div>
              <div className='p-5 max-w-full'>
                <BarChart dataLabels={usesLabels} colors={false} datasets={usesDatasets} />
              </div>
            </>
          )}
        </Card>
      </section>
    </WidgetLayout>
  );
}
